document.addEventListener('DOMContentLoaded', function() {
  const grid = document.getElementById('custom-all-products-grid');
  if (!grid) return;

  let page = 2; // start from page 2
  let loading = false;

  window.addEventListener('scroll', function() {
    if (loading) return;

    const scrollPosition = window.scrollY + window.innerHeight;
    const bottomPosition = document.body.offsetHeight - 300;

    if (scrollPosition >= bottomPosition) {
      loading = true;
      document.getElementById('infinite-scroll-loader').style.display = 'block';
      
      const url = `/collections/all?page=${page}&view=ajax`;

      fetch(url)
        .then(res => res.text())
        .then(data => {
          const parser = new DOMParser();
          const html = parser.parseFromString(data, 'text/html');
          const newProducts = html.querySelector('#custom-all-products-grid');

          if (newProducts && newProducts.innerHTML.trim().length > 0) {
            grid.insertAdjacentHTML('beforeend', newProducts.innerHTML);
            page++;
            loading = false;
            document.getElementById('infinite-scroll-loader').style.display = 'none';
          } else {
            document.getElementById('infinite-scroll-loader').innerText = 'No more products';
          }
        });
    }
  });
});
